import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import {
    DataGrid,
    GridToolbarContainer
} from '@mui/x-data-grid';
import AddLineItem from './AddLineItem';
import {
    Divider,
    Grid,
    Box,
    Button,
    Card,
    CardHeader,
    CardContent,
    IconButton,
    Tooltip,
    Typography
} from "@mui/material";
import Alert from '@mui/material/Alert';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { updateLineitemDatas } from '../../Settings/ProductLineItems/lineitemSettingsSlice';
import { fetchSkuINfo,resetLineItemSettingsState, patchOrderLineItems } from '../../../pages/Settings/ProductLineItems/lineitemSettingsSlice';

const getUniqueId = () => {
    return "SCIT" + Date.now().toString(36) + Math.random().toString(36).substr(2)
}

const LineItems = ({ lineItems, dispatchLineItemCallback, isDuplicateOrder, customLineItems, setCustomLineItems,isReturnOrder,docIdCreate,newOrderFormData,reportName,values,isShipmentCreationFlow,showFieldErrors,activeCountryCode,activeSenderCountryCode,meta  }) => {
    const dispatch = useDispatch();
    const profile = useSelector(state => state.auth);
    const skuInfos = useSelector(state => state.lineitemsettings.skuINfo);
    // Extract the specific strings we want to watch to ensure the Effect fires
    const countryCode = values?.country_code;
    const senderCountryCode = values?.sender_country_code;
    const shippingCountryCode = newOrderFormData?.shipping_address?.country_code;
    const [checkedIds, setCheckedIds] = useState([]);
    const [checkedItems, setCheckedItems] = useState([]);
    // const [pageSize, setPageSize] = useState(5);
    const [addLineItemVisible, setAddLineItemVisible] = useState(false)
    const [removeLineItemId, setRemoveLineItemId] = useState("")
    const [editLineItemId, setEditLineItemId] = useState("")
    const [skuInfo, setSkuInfo] = useState([]);
    const [showAlert, setShowAlert] = useState(false);
    const assignedStoreName = profile?.profile?.assigned_store_id?.toString().trim() || "";
    const [paginationModel, setPaginationModel] = React.useState({
        pageSize: 5,
        page: 0,
      });
    const [addLineItemData, setaddLineItemData] = useState({
        "line_item_id": getUniqueId(),
        "product_id": "",
        "sku":"",
        "product_desc": "",
        "product_url": "",
        "product_price": "",
        "hs_tariff_code": "",
        "hs_tariff_code_country": "",
        "edit_line_item_id": "",
        "quantity": "",
        "tracking_number":"",
        "origin_country_code":"",
        "currency":""
    })
    const [lineItemErrors, setLineItemsErrors] = useState({
        "line_item_id": "",
        "product_id": "",
        "sku":"",
        "product_desc": "",
        "product_url": "",
        "product_price": "",
        "hs_tariff_code": "",
        "hs_tariff_code_country": "",
        "quantity": "",
        "origin_country_code":"",
        "currency":""
    });
    let initialColumns = [
        {
            field: 'action',
            headerName: 'Action',
            headerClassName: 'super-app-theme--header',
            width: 110,
            sortable: false,
            disableColumnMenu: true,
            hide: (customLineItems.length == 0),
            align: 'center',       // Center-aligns the cell wrapper container
            headerAlign: 'center', // Center-aligns the column header label text
            renderCell: (params) => {
                const isEditDisabled = !!(params.row.tracking_number && params.row.tracking_number !== "");
                const isDeleteDisabled = isEditDisabled || isShipmentCreationFlow;
                
                const colors = {
                    editActive: '#1976d2',
                    deleteActive: '#d32f2f',
                    disabled: '#bdbdbd'
                };

                if (params.row && params.row.line_item_id) {
                    return (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, height: '100%', width: '100%' }}>
                            <span>
                                <Tooltip title={isEditDisabled ? "Tracking assigned - cannot edit" : "Edit"} placement="top">
                                    <IconButton 
                                        size="small"
                                        disabled={isEditDisabled}
                                        onClick={() => setEditLineItemId(params.row.line_item_id)} 
                                        sx={{
                                            color: isEditDisabled ? colors.disabled : colors.editActive,
                                            padding: '6px',
                                            borderRadius: '8px',
                                            border: '1px solid',
                                            borderColor: isEditDisabled ? '#F1F5F9' : '#E2E8F0',
                                            backgroundColor: '#FFFFFF',
                                            transition: 'all 0.15s ease-in-out',
                                            '&:hover': {
                                                backgroundColor: isEditDisabled ? 'transparent' : 'rgba(25, 118, 210, 0.04)',
                                                borderColor: isEditDisabled ? '#F1F5F9' : '#CBD5E1',
                                            }
                                        }}
                                    >
                                        <EditIcon sx={{ fontSize: '15px' }} />
                                    </IconButton>
                                </Tooltip>
                            </span>

                            <span>
                                <Tooltip title={isDeleteDisabled ? "Cannot delete item in this state" : "Delete"} placement="top">
                                    <IconButton 
                                        size="small"
                                        disabled={isDeleteDisabled}
                                        onClick={() => setRemoveLineItemId(params.row.line_item_id)}
                                        sx={{
                                            color: isDeleteDisabled ? colors.disabled : colors.deleteActive,
                                            padding: '6px',
                                            borderRadius: '8px',
                                            border: '1px solid',
                                            borderColor: isDeleteDisabled ? '#F1F5F9' : '#FEE2E2',
                                            backgroundColor: '#FFFFFF',
                                            transition: 'all 0.15s ease-in-out',
                                            '&:hover': {
                                                backgroundColor: isDeleteDisabled ? 'transparent' : 'rgba(211, 47, 47, 0.04)',
                                                borderColor: isDeleteDisabled ? '#F1F5F9' : '#FCA5A5',
                                            }
                                        }}
                                    >
                                        <DeleteOutlineOutlinedIcon sx={{ fontSize: '15px' }} />
                                    </IconButton>
                                </Tooltip>
                            </span>
                        </Box>
                    );
                } else {
                    return <Typography variant="body2" sx={{ color: '#94A3B8', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>-</Typography>;
                }
            }
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            headerClassName: 'super-app-theme--header',
            width: 100,
            sortable: false,
            align: 'center',       // Center-aligns the cell wrapper container
            headerAlign: 'center', // Center-aligns the column header label text
            renderCell: (params) => {
                const qty = params.row.quantity;
                return (
                    <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
                        {qty && qty !== "" ? qty : 1}
                    </Typography>
                );
            }
        },
        {
            field: 'product_price',
            headerName: 'Price',
            headerClassName: 'super-app-theme--header',
            width: 110,
            sortable: false,
            align: 'center',       // Center-aligns the cell wrapper container
            headerAlign: 'center', // Center-aligns the column header label text
            renderCell: (params) => {
                // Priority: inventory_product_price -> product_price
                const price = params.row.inventory_product_price ?? params.row.product_price;
                return (
                    <Typography variant="body2" sx={{ color: '#0F172A', fontWeight: 700, fontSize: '13.5px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
                        {price && price !== "" ? price : "-"}
                    </Typography>
                );
            }
        },
        {
            field: 'sku',
            headerName: 'SKU',
            headerClassName: 'super-app-theme--header',
            width: 200,
            sortable: false,
            align: 'center',       // Center-aligns the cell wrapper container
            headerAlign: 'center', // Center-aligns the column header label text
            renderCell: (params) => {
                // Priority: inventory_sku -> sku
                const sku = params.row.inventory_sku ?? params.row.sku;
                return (
                    <Typography variant="body2" sx={{ color: '#1E293B', fontWeight: 600, fontSize: '13px', fontFamily: 'monospace', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', height: '100%', width: '100%' }}>
                        {sku && sku !== "" ? sku : "-"}
                    </Typography>
                );
            }
        },
        {
            field: 'product_desc',
            headerName: 'Product Description',
            headerClassName: 'super-app-theme--header',
            width: 300,
            sortable: false,
            align: 'center',       // Center-aligns the cell wrapper container
            headerAlign: 'center', // Center-aligns the column header label text
            renderCell: (params) => {
                // Priority: inventory_product_desc -> product_desc
                const desc = params.row.inventory_product_desc ?? params.row.product_desc;
                return (
                    <Typography 
                        variant="body2" 
                        sx={{ 
                            color: '#475569', 
                            fontWeight: 500, 
                            fontSize: '13px', 
                            display: 'inline-flex', 
                            alignItems: 'center', 
                            justifyContent: 'center', // Centers text alignment layout within typography container bounding box
                            height: '100%',
                            width: '100%',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                        }}
                    >
                        {desc && desc !== "" ? desc : "-"}
                    </Typography>
                );
            }
        }
    ];
    const [columns, setColumns] = useState(initialColumns)

    const updateButtonDisable = (item) => {
        let updateButtonDisable = true;
            if (!item.tracking_number || item.tracking_number === "") {
                updateButtonDisable = false;
            }
        return updateButtonDisable;
    }

    const onCheckedIdsChange = (items) => {
        let productLineItem = [];
        const shouldUncheck = !!(profile?.profile?.uncheck_line_items_default === true);
        const isFromPicklist = reportName === "ORDER_PICKLIST";
        // Ensure we are pulling from the correct state (auth vs profile)
        const assignedStoreName = profile?.profile?.assigned_store_id || "";

        if (items && items.length > 0) {
            if (shouldUncheck && !isFromPicklist) {
                productLineItem = [];
            } 
            else if (isFromPicklist) {
                items.forEach((item) => {
                    // 2. Logic: Must be packed
                    const isPacked = item.is_packed === true;
                    
                    // 3. Logic: Match Store (Handle Case Sensitivity and Spaces)
                    const itemLocation = item.location?.id || "";
                    const matchesStore = assignedStoreName === "" || itemLocation === assignedStoreName;
                    
                    if (item.line_item_id && isPacked && matchesStore) {
                        // 4. Force ID to string immediately to avoid BigInt/Precision issues in DataGrid
                        productLineItem.push(item.line_item_id.toString());
                    }
                });
            } 
            else if (isDuplicateOrder) {
                items.forEach((item) => {
                    if (item.line_item_id) {
                        productLineItem.push(String(item.line_item_id));
                    }
                });
            }
            else {
                items.forEach((item) => {
                    if (item.line_item_id && !item.tracking_number && !isReturnOrder) {
                        productLineItem.push(String(item.line_item_id));
                    }
                });
            }
        }
        // This updates the state for the NEXT render
        // setCheckedIds(productLineItem);
        return productLineItem;
        
    };

    const onAddLineItemModalClose = () => {
        setRemoveLineItemId("")
        setEditLineItemId("")
        setaddLineItemData({
            "line_item_id": getUniqueId(),
            "product_id": "",
            "sku":"",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "edit_line_item_id": "",
            "quantity": "",
            "tracking_number":"",
            "origin_country_code":"",
            "currency":""
        })
        setLineItemsErrors({
            "line_item_id": "",
            "product_id": "",
            "sku":"",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "origin_country_code":"",
            "quantity": "",
            "currency":""
        })
        setAddLineItemVisible(false)
    }

    const checkBoxCompute = (tempCheckedIds, tempCheckedItems, item, currentSelectedIds) => {
        const line_item_id = (item.line_item_id) ? item.line_item_id.toString() : ""
        const index = tempCheckedIds.indexOf(line_item_id);
        const method = (currentSelectedIds.indexOf(line_item_id) > -1)
        if (method) {
            if (index === -1) {
                tempCheckedIds.push(line_item_id);
                tempCheckedItems.push(item)
            }
        } else if (!method) {
            if (index > -1) {
                tempCheckedIds.splice(index, 1);
                tempCheckedItems.splice(index, 1);
            }
        }
        return [tempCheckedIds, tempCheckedItems];
    }

    const onSelectionChange = (currentSelectedIds, currentAllItems) => {
        let tempCheckedIds = [...checkedIds]
        let tempCheckedItems = [...checkedItems];
        currentAllItems && currentAllItems.length != 0 && currentAllItems.map((item) => (
            checkBoxCompute(tempCheckedIds, tempCheckedItems, item, currentSelectedIds)
        ))
        setCheckedIds(tempCheckedIds)
        setCheckedItems(tempCheckedItems)
    }

    const formDataHandler = e => {
        const { name, value } = e.target
        setaddLineItemData({
            ...addLineItemData,
            [name]: value
        })
        validateLineItemData();
    }

    const dispatchHandler = e => {
        const { name, value } = e.target
        dispatch(fetchSkuINfo(value));
    }

    const handleBlur = e => {
        const { name, value } = e.target
        if (name === 'product_price' && value !== '') {
            setaddLineItemData({
            ...addLineItemData,
            [name]: parseFloat(value).toFixed(2)
            })
        }
        if (name === 'product_desc' && value !== '') {
            setaddLineItemData({
            ...addLineItemData,
            [name]: value.replace(/[^a-zA-Z0-9]/g, " ")
            })
        }
        setLineItemsErrors({
            ...lineItemErrors,
            [name]: ""
        })
    }
    const handleHsCodeBlur = () => {
        const raw = addLineItemData.hs_tariff_code.replace(/\D/g, ''); // Remove non-digits
        
        if (raw.length === 10) {
            const formatted = `${raw.slice(0, 4)}.${raw.slice(4, 6)}.${raw.slice(6, 8)}.${raw.slice(8, 10)}`;

            setaddLineItemData(prev => {
                // 1. Start with the base update
                const newState = {
                    ...prev,
                    hs_tariff_code: formatted
                };

                // 2. Only add/update the inventory key if it already exists in the object
                if (Object.prototype.hasOwnProperty.call(prev, 'inventory_hs_tariff_code')) {
                    newState.inventory_hs_tariff_code = formatted;
                }

                return newState;
            });
        }
    };
    // const handleHsCodeBlur = () => {
    //     const raw = addLineItemData.hs_tariff_code.replace(/\D/g, ''); // Remove non-digits
    //     if (raw.length === 10) {
    //         const formatted = `${raw.slice(0, 4)}.${raw.slice(4, 6)}.${raw.slice(6, 8)}.${raw.slice(8, 10)}`;

    //         setaddLineItemData(prev => ({
    //         ...prev,
    //             hs_tariff_code: formatted,
    //             [`inventory_hs_tariff_code`]: formatted
    //         }));
    //     }
    // };


    const dispatchCountryCode = (id) => {
        setaddLineItemData({
            ...addLineItemData,
            ['origin_country_code']: id
        })
        validateLineItemData();
    }

    const isFloatValue = (value) => {
        value = Number(value);
        if (!isNaN(value) && value.toString().indexOf('.') != -1) {
            return true;
        }
        return false;
    }

    const isIntegerValue = (value) => {
        value = Number(value);
        if (Number.isInteger(value)) {
            return true;
        }
        return false;
    }

    const validateLineItemData = () => {
        let isValid = true
        let lineItemErrorsTemp = {
            "line_item_id": "",
            "product_id": "",
            "sku":"",
            "product_desc": "",
            "product_url": "",
            "product_price": "",
            "hs_tariff_code": "",
            "hs_tariff_code_country": "",
            "origin_country_code":"",
            "quantity": "",
            "currency":""
        };

        // if (addLineItemData.product_id === "" || addLineItemData.product_id === undefined  ||  addLineItemData.product_id === null) {
        //     isValid = false
        //     lineItemErrorsTemp.product_id = "Product id is required";
        // }
        if (addLineItemData.sku == "") {
            isValid = false
            lineItemErrorsTemp.sku = "SKU is required";
        }
        if (addLineItemData.product_desc == "" || addLineItemData.product_desc.length <= 1 || addLineItemData.product_desc.length >= 100) {
            isValid = false
            lineItemErrorsTemp.product_desc = "Product desc is required and should be more than 5 character long";
        }

        // if (addLineItemData.product_url == "" || addLineItemData.product_url.length >= 250) {
        //     isValid = false
        //     lineItemErrorsTemp.product_url = "Product url is required and should be valid";
        // }

        if (addLineItemData.product_price == "" || (!isFloatValue(addLineItemData.product_price) && !isIntegerValue(addLineItemData.product_price))) {
            isValid = false
            lineItemErrorsTemp.product_price = "Product price is required and should be valid";
        }
        if (addLineItemData.product_price<=0) {
            isValid = false
            lineItemErrorsTemp.product_price = "The product price must be a positive number";
        }
        if (addLineItemData.quantity == "" || !isIntegerValue(addLineItemData.quantity)) {
            isValid = false
            lineItemErrorsTemp.quantity = "Product quantity is required and should be a valid";
        }if (addLineItemData.currency == "") {
            isValid = false
            lineItemErrorsTemp.currency = "Currency is required";
        }if (addLineItemData.hs_tariff_code == "" || addLineItemData.hs_tariff_code.replace(/\./g, '').length!==10) {
            isValid = false
            lineItemErrorsTemp.hs_tariff_code = "HsCode is required and Hscode must be 10 digits";
        }if (addLineItemData.origin_country_code == "") {
            isValid = false
            lineItemErrorsTemp.origin_country_code = "Country of origin is required";
        }

        setLineItemsErrors(lineItemErrorsTemp)
        return isValid
    }

    const onAddLineItemClick = () => {
        let userid = profile?.profile?.id || ""
        if (validateLineItemData()) {
            const customLineItemData = [...customLineItems];

            // --- CASE 1: ADD NEW ITEM ---
            if (addLineItemData.edit_line_item_id === "") {
                const { edit_line_item_id, ...newItemData } = addLineItemData;
                
                const updatedItems = [...customLineItemData, newItemData];
                setCustomLineItems(updatedItems);
                
                if(isShipmentCreationFlow){
                    const payload = {
                        item_reference_id: docIdCreate, 
                        action_type: 'ADD',
                        item_data: newItemData 
                    };
                    dispatch(patchOrderLineItems(payload, userid,meta));
                }
                onAddLineItemModalClose();

            // --- CASE 2: EDIT EXISTING ITEM ---
            } else if (addLineItemData.edit_line_item_id !== "") {
                const originalItem = customLineItemData.find(i => i.line_item_id == addLineItemData.edit_line_item_id);
                
                // Whitelist of fields coming from the Form
                const formFields = [
                    'product_id', 'sku', 'product_desc', 'product_url', 
                    'product_price', 'hs_tariff_code', 'hs_tariff_code_country', 
                    'origin_country_code', 'quantity', 'currency'
                ];

                // Strict Dirty Check
                const isDirty = formFields.some(field => originalItem[field] !== addLineItemData[field]);

                if (isDirty) {
                    // Prepare the payload
                    const { edit_line_item_id, ...payloadData } = { ...addLineItemData };

                    // --- INVENTORY PROTECTION LOGIC ---
                    // If inventory exists, update the inventory field and RESTORE the original actual field
                    // This ensures the "actual" database field remains unchanged by this specific edit
                    if (payloadData.inventory_product_price !== undefined) {
                        payloadData.inventory_product_price = payloadData.product_price;
                        payloadData.product_price = originalItem.product_price; 
                    }
                    if (payloadData.inventory_hs_tariff_code !== undefined) {
                        payloadData.inventory_hs_tariff_code = payloadData.hs_tariff_code;
                        payloadData.hs_tariff_code = originalItem.hs_tariff_code;
                    }
                    if (payloadData.inventory_origin_country_code !== undefined) {
                        payloadData.inventory_origin_country_code = payloadData.origin_country_code;
                        payloadData.origin_country_code = originalItem.origin_country_code;
                    }
                    if (payloadData.inventory_hs_tariff_code_country !== undefined) {
                        payloadData.inventory_hs_tariff_code_country = payloadData.hs_tariff_code_country;
                        payloadData.hs_tariff_code_country = originalItem.hs_tariff_code_country;
                    }
                    if (payloadData.inventory_currency !== undefined) {
                        payloadData.inventory_currency = payloadData.currency;
                        payloadData.currency = originalItem.currency;
                    }
                    if (payloadData.inventory_sku !== undefined) {
                        payloadData.inventory_sku = payloadData.sku;
                        payloadData.sku = originalItem.sku;
                    }
                    if (payloadData.inventory_product_desc !== undefined) {
                        payloadData.inventory_product_desc = payloadData.product_desc;
                        payloadData.product_desc = originalItem.product_desc;
                    }
                    if (payloadData.inventory_product_url !== undefined) {
                        payloadData.inventory_product_url = payloadData.product_url;
                        payloadData.product_url = originalItem.product_url;
                    }
                    if (payloadData.inventory_product_id !== undefined) {
                        payloadData.inventory_product_id = payloadData.product_id;
                        payloadData.product_id = originalItem.product_id;
                    }

                    // Update Local UI State (Merge payload into existing list)
                    const updatedList = customLineItemData.map(item => {
                        if (item.line_item_id == addLineItemData.edit_line_item_id) {
                            return { ...item, ...payloadData };
                        }
                        return item;
                    });
                    
                    setCustomLineItems(updatedList);

                    // API DISPATCH
                    if(isShipmentCreationFlow){
                        const payload = {
                            item_reference_id: docIdCreate,
                            action_type: 'EDIT',
                            item_data: payloadData
                        };
                        dispatch(patchOrderLineItems(payload, userid,meta));
                    }
                } else {
                    console.log("No changes detected, skipping dispatch.");
                }
                
                onAddLineItemModalClose();
            } 

        } else {
            console.log("Validation errors in line items form");
        }
    };

    function generate4DigitNumber() {
        const now = new Date();
        const seconds = now.getSeconds(); // 0–59
        const milliseconds = now.getMilliseconds(); // 0–999

        // Combine seconds and milliseconds to seed randomness
        const seed = seconds * 1000 + milliseconds;

        // Use seed to generate a 4-digit number
        const random = Math.floor((Math.random() * seed) % 10000);

        // Pad with leading zeros if needed
        return random.toString().padStart(4, '0');
    }

    const onLineItemsChange = (items) => {
        if (items) {
            let productLineItem = [];
            items.forEach((item) => {
                if (item) {
                    let mappedItem = {
                        "line_item_id": item.line_item_id || getUniqueId(),
                        "product_id": item.product_id || "",
                        "sku": item.sku || "",
                        "product_desc": (item.product_desc || "").replace(/[^a-zA-Z0-9]/g, " "),
                        // Store standard price exactly as it is in the source
                        "product_price": item.product_price ? parseFloat(String(item.product_price).replace('$', '')).toFixed(2) : "",
                        "quantity": item.quantity || "",
                        "tracking_number": (!isDuplicateOrder && !isReturnOrder) ? (item.tracking_number || "") : "",
                        "currency": item.currency || "",
                        "hs_tariff_code": item.hs_tariff_code || "",
                        "hs_tariff_code_country": item.hs_tariff_code_country || "",
                        "origin_country_code": item.origin_country_code || "",
                        "is_packed": item.is_packed ?? false,
                        "location": item.location || {},
                    };

                    // DYNAMICALLY ADD ALL INVENTORY KEYS (preserves inventory_product_price separately)
                    Object.keys(item).forEach(key => {
                        if (key.startsWith('inventory_')) {
                            mappedItem[key] = item[key];
                        }
                    });

                    productLineItem.push(mappedItem);
                }
            });

            const sortedLineItems = productLineItem.sort((a, b) => {
                const aDisabled = a.tracking_number && a.tracking_number !== "" ? 1 : 0;
                const bDisabled = b.tracking_number && b.tracking_number !== "" ? 1 : 0;
                return aDisabled - bDisabled;
            });

            setCustomLineItems(sortedLineItems);
        }
    };

    useEffect(() => {
        dispatchLineItemCallback(checkedIds)
    }, [checkedIds])

    useEffect(() => {
        if (lineItems && (typeof lineItems !== 'undefined') && lineItems.length != 0) {
            onCheckedIdsChange(lineItems)
            onLineItemsChange(lineItems)
        }
    }, [lineItems])

    useEffect(() => {
        setColumns(initialColumns)
        if (customLineItems && customLineItems.length > 0) {
            const newSelectedIds =onCheckedIdsChange(customLineItems);
            // ONLY update if we found IDs, or if it's the very first load
            // This prevents the "Reset to empty" flicker
            if (newSelectedIds.length > 0) {
                setCheckedIds(newSelectedIds);
            }else if (customLineItems.length === 0) {
                setCheckedIds([]);
            }
        }
        // Sync with Backend
        if (customLineItems.length > 0) {
            let line_items = customLineItems;
            let item_reference_id = docIdCreate;
            let finalData = {
                item_reference_id,
                line_items
            };
            dispatch(updateLineitemDatas(finalData));
        }
    }, [customLineItems])

    useEffect(() => {
        if (removeLineItemId != "" && removeLineItemId != "undefined") {
            let customLineItemData = [...customLineItems];
            let newLineItemData = [];
            customLineItemData.map((item) => {
                if (item && item.line_item_id && item.line_item_id != removeLineItemId) {
                    newLineItemData.push(item)
                }
            })
            setCustomLineItems(newLineItemData)
        }
    }, [removeLineItemId])

    useEffect(() => {
        if (editLineItemId != "" && editLineItemId != "undefined" && !_.isUndefined(_.find(customLineItems, ['line_item_id', editLineItemId]))) {
            let editData = { ..._.find(customLineItems, ['line_item_id', editLineItemId]) };

            // --- UI DISPLAY PRIORITY LOGIC ---
            // If inventory keys exist, show them in the form fields instead of actual values
            if (editData.inventory_product_price !== undefined) {
                editData.product_price = editData.inventory_product_price;
            }
            if (editData.inventory_hs_tariff_code !== undefined) {
                editData.hs_tariff_code = editData.inventory_hs_tariff_code;
            }
            
            if (editData.inventory_currency !== undefined) {
                editData.currency = editData.inventory_currency;
            }
            if (editData.inventory_origin_country_code !== undefined) {
                editData.origin_country_code = editData.inventory_origin_country_code;
            }
            if (editData.inventory_product_desc !== undefined) {
                editData.product_desc = editData.inventory_product_desc;
            }
            if (editData.inventory_product_url !== undefined) {
                editData.product_url = editData.inventory_product_url;
            }
            if (editData.inventory_sku !== undefined) {
                editData.sku = editData.inventory_sku;
            }
            if (editData.inventory_product_id !== undefined) {
                editData.product_id = editData.inventory_product_id;
            }

            editData[`edit_line_item_id`] = editLineItemId;
            setaddLineItemData(editData);
            setAddLineItemVisible(true);
        }
    }, [editLineItemId]);
    
    useEffect(() => {
        if (skuInfos && skuInfos.data && skuInfos.data.skuinfos && skuInfos.data.skuinfos.length > 0) {
            setSkuInfo(skuInfos.data.skuinfos && skuInfos.data.skuinfos.length > 0 ? skuInfos.data.skuinfos : [])
        }
        
        if (skuInfos && skuInfos.data && skuInfos.data.skuDatas && Object.keys(skuInfos.data.skuDatas).length > 0) {
            const item = skuInfos.data.skuDatas;

            // 1. Identify priority values for UI Display
            const displayPrice = item.product_price || "";
            const displayHs = item.hs_tariff_code || "";
            const displayCoo = item.origin_country_code || "";

            // 2. Build the Base Object with standard keys (for the Form Inputs)
            // Product ID auto-generation needs to be removed, as requested by Vijay. (2026-05-14)
            let baseData = {
                product_id:item.product_id || "",
                sku: item.sku,
                product_desc:item.product_desc || "",
                product_url: item.product_url || "",
                product_price: displayPrice,
                hs_tariff_code: displayHs,
                hs_tariff_code_country: item.hs_tariff_code_country || "",
                quantity: 1 || "",
                tracking_number: "",
                origin_country_code: displayCoo,
                currency:item.inventory_currency || item.currency || ""
            };

            /**
             * 3. DYNAMIC INVENTORY PREFIXING
             * Loop through the raw item data. 
             * Exclude technical IDs, then add prefix to everything else.
             */
            Object.keys(item).forEach(key => {
                // Skip the keys you want to keep standard
                if (key === "line_item_id" || key === "edit_line_item_id" || key === "quantity") {
                    return; 
                }

                // If it's already an inventory key, just keep it
                if (key.startsWith('inventory_')) {
                    baseData[key] = item[key];
                } else {
                    // For all other keys (sku, product_desc, etc.), create the inventory_ counterpart
                    baseData[`inventory_${key}`] = item[key];
                }
            });

            // 4. Set State with correct Line Item ID handling
            if (editLineItemId !== "") {
                setaddLineItemData({ 
                    ...baseData, 
                    line_item_id: editLineItemId, 
                    edit_line_item_id: editLineItemId 
                });
            } else {
                setaddLineItemData({ 
                    ...baseData, 
                    line_item_id: getUniqueId(), 
                    edit_line_item_id: "" 
                });
            }
           
            // 5. Validation/Error cleanup
            setLineItemsErrors(prev => ({
                ...prev,
                sku: item.sku ? "" : prev.sku,
                product_desc: item.product_desc ? "" : prev.product_desc,
                product_price: baseData.product_price ? "" : prev.product_price,
                hs_tariff_code: baseData.hs_tariff_code ? "" : prev.hs_tariff_code,
                origin_country_code: baseData.origin_country_code ? "" : prev.origin_country_code,
                quantity: "",
                currency: item.currency ? "" : prev.currency
            }));

        } else {
            // Reset Logic / Manual Entry Mode
            setaddLineItemData(prev => {
                // Determine the ID: 
                // 1. If we are editing, use the existing edit ID.
                // 2. If it's a new entry and prev already has an ID, keep it.
                // 3. Otherwise, generate a fresh one.
                // Product ID auto-generation needs to be removed, as requested by Vijay. (2026-05-14)
                const finalId = editLineItemId !== "" 
                    ? editLineItemId 
                    : (prev.line_item_id ? prev.line_item_id : getUniqueId());
                return {
                    ...prev,
                    line_item_id: finalId,
                    edit_line_item_id: editLineItemId !== "" ? editLineItemId : "",
                    product_id: "",
                    product_desc: "",
                    product_url: "",
                    product_price: "",
                    hs_tariff_code: "",
                    hs_tariff_code_country: "",
                    origin_country_code: "",
                    quantity: 1,
                    currency: "",
                    // sku: prev.sku is already preserved by ...prev
                };
            });
        }
    }, [skuInfos]);


    useEffect(() => {
        if (editLineItemId === "" || editLineItemId === "undefined" ){
            setaddLineItemData({
                "line_item_id": editLineItemId,
                "product_id": "",
                "sku":"",
                "product_desc": "",
                "product_url": "",
                "product_price": "",
                "hs_tariff_code": "",
                "hs_tariff_code_country": "",
                "edit_line_item_id": "",
                "quantity": "",
                "tracking_number":"",
                "origin_country_code":"",
                "currency":""
            })
        }
        if(!addLineItemVisible){
            dispatch(resetLineItemSettingsState());
        }
    }, [addLineItemVisible])

   
    useEffect(() => {
        // 1. Determine Country String
        const country = isReturnOrder 
            ? (activeSenderCountryCode || "") 
            : (activeCountryCode || newOrderFormData?.shipping_address?.country_code || "");

        const upperCountry = country.toString().toUpperCase().trim();
        const isCanada = upperCountry === "CA" || upperCountry === "CANADA";
        const canBypassItems = isCanada && !isShipmentCreationFlow;

        // 2. Logic: Should we show the error?
        const isMissingSelection = checkedIds.length === 0;
        
        if (showFieldErrors && isMissingSelection && !canBypassItems) {
            setShowAlert(true);
        } else {
            setShowAlert(false);
        }

    // By adding submitCount and direct strings here, it is IMPOSSIBLE for React to ignore the change
    }, [
        showFieldErrors, 
        activeCountryCode, 
        activeSenderCountryCode, 
        checkedIds.length, 
        isReturnOrder, 
        isShipmentCreationFlow
    ]);
    return (
        <>
           {/* LEFT PART MODULE: Line Items Grid presentation canvas */}
            <Card
                sx={{ 
                    width: '100%',
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E2E8F0',
                    borderRadius: '16px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.02)',
                    overflow: 'hidden',
                    display: 'flex',         
                    flexDirection: 'column',  
                    height: '100%'           
                }}
                className="sc--cardhead--details"
            >
                <CardHeader
                    title={
                        <Typography variant="h6" component="h2" sx={{ fontWeight: 800, color: '#0F172A', fontSize: '15px' }}>
                            Line Item
                        </Typography>
                    }
                    action={
                        <>
                            {((typeof lineItems == 'undefined') || lineItems.length == 0 || isDuplicateOrder) &&
                                <Button 
                                    variant="outlined" 
                                    size="small"
                                    aria-label="settings" 
                                    onClick={() => setAddLineItemVisible(true)}
                                    sx={{
                                        textTransform: 'none',
                                        borderRadius: '8px',
                                        fontWeight: 700,
                                        fontSize: '12.5px',
                                        height: '32px',
                                        borderColor: '#1976d2',
                                        color: '#1976d2',
                                        '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.04)', borderColor: '#115293' }
                                    }}
                                >
                                    Add Line Item
                                </Button>
                            }
                        </>
                    }
                    sx={{ p: 2.5, backgroundColor: '#FFFFFF', flexShrink: 0 }}
                />
                <Divider sx={{ borderColor: '#E2E8F0', flexShrink: 0 }} />
                
                {/* FIXED: Removed display: 'flex' and flexGrow from CardContent to drop top structural layout spacing */}
                <CardContent sx={{ p: 3 }}>
                    <Box
                        component="form"
                        noValidate
                        autoComplete="off"
                        sx={{ width: '100%' }} // FIXED: Removed flex layout configurations to pull grid upward
                    >
                        <AddLineItem
                            addLineItemVisible={addLineItemVisible}
                            onAddLineItemModalClose={onAddLineItemModalClose}
                            formDataHandler={formDataHandler}
                            dispatchHandler={dispatchHandler}
                            dispatchCountryCode={dispatchCountryCode}
                            onAddLineItemClick={onAddLineItemClick}
                            addLineItemData={addLineItemData}
                            editLineItemId={editLineItemId}
                            errors={lineItemErrors}
                            handleBlur={handleBlur}
                            handleHsCodeBlur={handleHsCodeBlur}
                            skuOnly={skuInfo}
                            isShipmentCreationFlow={isShipmentCreationFlow}
                        />
                    
                        {showAlert && (
                            <Alert 
                                severity="error" 
                                variant="outlined"
                                sx={{ mb: 2, borderRadius: '10px', fontWeight: 500, fontSize: '13px', flexShrink: 0 }}
                            >
                                Please select at least one item to proceed.
                            </Alert>
                        )}

                        {/* FIXED: Removed flexGrow from this wrapper to prevent the grid from vertically centering inside an expanding card */}
                        <Box className="sc--form--center" sx={{ width: '100%', mt: 1 }}>
                            <DataGrid
                                sx={{
                                    border: '1px solid #E2E8F0',
                                    borderRadius: '12px',
                                    overflow: 'hidden',
                                    '& .MuiDataGrid-topContainer': { backgroundColor: '#F8FAFC' },
                                    '& .MuiDataGrid-columnHeader': { color: '#475569', fontWeight: 700, fontSize: '12.5px' },
                                    '& .MuiDataGrid-row': { borderBottom: '1px solid #F1F5F9', '&:hover': { backgroundColor: '#F8FAFC' } },
                                    '& .MuiLinearProgress-root': { height: '3px', backgroundColor: '#E2E8F0', '& .MuiLinearProgress-bar': { backgroundColor: '#1976d2' } }
                                }}
                                disableRowSelectionOnClick
                                getRowId={(row) => row.line_item_id.toString()}
                                rows={customLineItems || []}
                                columns={columns}
                                autoHeight={true}
                                checkboxSelection
                                disableColumnFilter={true}
                                disableColumnMenu={true}
                                rowSelectionModel={checkedIds}
                                isRowSelectable={(params) => {
                                    const isFromPicklist = reportName === "ORDER_PICKLIST";
                                    const assignedStore = profile?.profile?.assigned_store_id || "";

                                    if (isFromPicklist) {
                                        const itemLocation = params.row.location?.id || "";
                                        return assignedStore === "" || itemLocation === assignedStore;
                                    }

                                    return !params.row.tracking_number;
                                }}
                                onRowSelectionModelChange={(newSelectionModel) => {
                                    setCheckedIds(newSelectionModel);
                                }}
                                pageSizeOptions={[5, 10, 25]}
                                paginationModel={paginationModel}
                                onPaginationModelChange={setPaginationModel}
                            />
                        </Box>
                    </Box>
                </CardContent>
            </Card>
        </>
    )
};

export default LineItems;